import { Box, CircularProgress, Grid } from "@mui/material";
import React from "react";
import { useSelector } from "../../../../store";
import { Base } from "../../../base";
import { useNavigate } from "react-router-dom";
import DisplayJobQuestions from "./DisplayJobQuestions";
import { Form, Formik } from "formik";
import { AnswerTypes } from "../../../../types/questionVM";
import { Inputs } from "../../../formInputs";

interface Props {
  handleReset: () => void;
  addEditJob: (values: any) => void;
  setCompleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleCompleteJob: (values: any) => void;
  completeModal: boolean;
}

const JobInformationTab: React.FC<Props> = (props) => {
  const {
    handleReset,
    addEditJob,
    setCompleteModal,
    handleCompleteJob,
    completeModal,
  } = props;
  const navigate = useNavigate();
  const { currentViewJobType } = useSelector((store) => store.jobType);
  const { job, status, getStatus } = useSelector((store) => store.job);

  return (
    <>
      {getStatus === "loading" ? (
        <Box
          sx={{
            borderRadius: "5px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Base.Text text="Loading, please wait..." variant="h3" />
          <CircularProgress />
        </Box>
      ) : (
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          sx={{
            padding: { md: 5, xs: 2 },
            mb: 2,
            paddingBottom: { md: 5, xs: 10 },
          }}
          rowGap={{ xs: 0, md: 2 }}
        >
          <Grid size={{ xs: 12 }}>
            <Formik
              initialValues={{
                ...job,
                // highlight:
                //   job.id > 0
                //     ? job.answers.find(
                //         (q) =>
                //           q.question?.answerType.id === AnswerTypes.WeeklyTask
                //       )?.value
                //     : false,
                answers: currentViewJobType?.questions.map((q, i) => {
                  const existingAnswer =
                    job.id > 0
                      ? job.answers.find((a) => a.question?.id === q.id)
                      : undefined;
                  return {
                    ...q,
                    id: existingAnswer?.id ?? 0,
                    question: q,
                    value:
                      q.answerType.id === AnswerTypes.DateRange
                        ? existingAnswer?.value ?? [null, null]
                        : existingAnswer?.value ?? "",
                    dateHighlight: existingAnswer?.dateHighlight ?? false,
                    calendarHighlight: existingAnswer?.calendarHighlight,
                  };
                }),
                // milestone: undefined,
                // milestoneTitle: "",
              }}
              onSubmit={addEditJob}
              enableReinitialize
            >
              {({ values, setFieldValue }) => (
                <Form noValidate>
                  <Grid container spacing={2}>
                    {currentViewJobType?.questions.map((question, i) => {
                      return (
                        <Grid
                          size={{
                            md:
                              question.answerType.id ===
                                AnswerTypes.Multiline ||
                              question.answerType.id === AnswerTypes.Dates ||
                              question.answerType.id === AnswerTypes.Section ||
                              question.answerType.id ===
                                AnswerTypes.Confidential ||
                              question.answerType.id === AnswerTypes.Site ||
                              question.answerType.id === AnswerTypes.WeeklyTask
                                ? 12
                                : 6,
                            xs: 12,
                          }}
                          key={question.id}
                        >
                          <DisplayJobQuestions
                            index={i}
                            jobType={currentViewJobType}
                            question={question}
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                  <>
                    <Grid size={{ xs: 12 }}>
                      <Grid
                        container
                        justifyContent={{ md: "flex-end", xs: "space-between" }}
                        columnGap={{ xs: 0, md: 2 }}
                      >
                        <Grid>
                          <Base.Button
                            text="Cancel"
                            type="secondary"
                            onClick={() => {
                              handleReset();
                              if (job.id > 0) {
                                navigate(`/job/view/${job.id}`);
                              } else {
                                navigate(-1);
                              }
                            }}
                          />
                        </Grid>
                        <Grid>
                          <Inputs.Submit
                            text="Save"
                            isSubmitting={status === "loading"}
                            disabled={values.answers?.some(
                              (a) =>
                                (Array.isArray(a.value)
                                  ? a.value.every((v: any) => v == null)
                                  : !a.value) && !!a.required,
                            )}
                          />
                        </Grid>
                        {job.id > 0 && !job.completedOn && (
                          <Grid>
                            <Base.Button
                              text="Complete"
                              onClick={() => setCompleteModal(true)}
                              disabled={values.answers?.some(
                                (a) =>
                                  (Array.isArray(a.value)
                                    ? a.value.every((v: any) => v == null)
                                    : !a.value) && !!a.required,
                              )}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </>
                  <Base.Dialog
                    open={completeModal}
                    handleCancel={() => setCompleteModal(false)}
                    confirmText="Complete"
                    confirmButtonType="primary"
                    title="Are you sure you would like to mark this job as complete?"
                    handleConfirm={() => handleCompleteJob(values)}
                    loading={status === "loading"}
                  />
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default JobInformationTab;
